<template>
  <div class="tab-special-goods">
    <div v-show="job.cargoType==='DG'" class="section">
      <div class="operations">
        <el-button
          v-show="btnshowAWindow"
          no="1"
          type="primary"
          size="mini"
          @click="showAWindowClickHandler"
        >{{ $t('SeaExport.ViewAssociatedBusiness') }}</el-button>
      </div>
    </div>
    <div v-if="job.cargoType==='DG'" class="section">
      <span class="title">{{ $t('SeaExport.DangerousGoods') }}</span>
      <div style="display:flex;flex-direction:row">
        <el-form
          label-width="190px"
          label-position="left"
          style="display:flex;flex-direction:column"
        >
          <el-form-item label-width="0" class="auto-width">
            <cargo-ag-grid
              no="2"
              :grid-options="danger.gridOptions"
              :grid-params.sync="danger.gridParams"
              :column-defs="dangerColumnDefs"
              :row-data="specialGoods"
              style="width:515px;height:200px"
              @gridReady="params=>danger.gridApi=params.api"
            />
            <div style="width:100%">
              <div style="float:left;padding:5px 5px 5px 0">
                <el-button no="3" type="primary" :disabled="!isEditing" @click="pm.addSpGoods()">{{ $t('SpecialGoods.Add') }}</el-button>
                <el-button no="4" type="danger" style="margin-left: 5px;" :disabled="!isEditing" @click="pm.delSpGoods()">{{ $t('SpecialGoods.Delete') }}</el-button>
                <el-upload
                  :disabled="!isEditing"
                  action="string"
                  :http-request="importSpGoods"
                  :show-file-list="false"
                  accept=".jpg, .jpeg, .png"
                  :before-upload="beforeUploadSpgGoods"
                  style="display: inline-block;padding-left: 5px;"
                >
                  <el-button :disabled="!isEditing" type="primary">{{ $t('SpecialGoods.Import') }}</el-button>
                </el-upload>
                <el-button no="5" style="margin-left: 5px;" type="primary" :disabled="!isEditing" @click="pm.fillInSpGoods()">{{ $t('SpecialGoods.FillIn') }}</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.CLASSNO')">
            <el-input v-if="!dangerousInputMode" v-model="editObj.danClassNo" no="6" :disabled="!isEditing" />
            <el-select
              v-if="dangerousInputMode"
              v-model="editObj.danClassNo"
              no="7"
              :disabled="!isEditing"
              :placeholder="!isEditing ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
              clearable
              filterable
            >
              <el-option
                v-for="(item,index) in danClassNos"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.SecondarySpecialGoods')">
            <el-input v-model="editObj.secondarySpecialGoods" no="8" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.UNNO')">
            <el-select
              ref="danUNNo"
              v-model="editObj.danUNNo"
              no="9"
              :disabled="!isEditing"
              :placeholder="!isEditing ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
              filterable
              clearable
              :allow-create="true"
              @blur="txtdDnUNNoFocusOutHandler()"
            >
              <el-option
                v-for="(item,index) in dangerousGoods"
                :key="index"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
            <!-- <el-input v-model="editObj.danUNNo" :disabled="!isEditing" /> -->
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.PACKING')">
            <el-input v-if="!dangerousInputMode" v-model="editObj.danPacking" no="10" :disabled="!isEditing" />
            <el-select
              v-if="dangerousInputMode"
              v-model="editObj.danPacking"
              no="11"
              :disabled="!isEditing"
              :placeholder="!isEditing ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
              clearable
            >
              <el-option
                v-for="(item,index) in packingGoods"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DangerousGoodsLabel')">
            <el-input v-model="editObj.danLable" no="12" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.EMS')">
            <el-input v-model="editObj.danEMS" no="13" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.Point')">
            <el-input v-model="editObj.danPoint" no="14" style="width: 85%;display: inline-block" :disabled="!isEditing" />
            <el-select
              v-model="editObj.flashPointUnit"
              :disabled="!isEditing"
              no="flashPointUnit"
              style="width: 15%;display: inline-block"
              placeholder=""
            >
              <el-option
                v-for="(item,index) in flashPointUnitArray"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="dangerousInputMode" :label="$t('SpecialGoods.TemperatureUnit')">
            <el-select
              v-model="editObj.temperatureUnit"
              no="15"
              :disabled="!isEditing"
              :placeholder="!isEditing ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
              :clearable="false"
            >
              <el-option
                v-for="(item,index) in temperatureUnits"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.Isolation')" class="bold">
            <el-input v-model="editObj.danIsolation" no="16" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MedicalEmergencyGuideNo')">
            <el-input v-model="editObj.danMfagNo" no="17" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.man24')">
            <el-input v-model="editObj.dan24man" no="18" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.tel24')">
            <el-input v-model="editObj.dan24tel" no="19" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Email2')">
            <el-input v-model="editObj.email" no="email" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Fax')">
            <el-input v-model="editObj.fax" no="fax" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
        <el-form
          label-width="120px"
          label-position="left"
          style="display:flex;flex-direction:column;margin-left:20px"
          :disabled="!isEditing"
        >
          <el-form-item :label="$t('SpecialGoods.ResponsibleParty')">
            <el-input v-model="editObj.responsibleParty" no="20" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.HSCODE')">
            <el-input v-model="editObj.hsCode" no="21" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.PickTime')">
            <el-input v-model="editObj.danPickTime" no="22" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.SeaPullution')">
            <el-input v-model="editObj.danSeaPullution" no="23" :placeholder="!isEditing ? '' : $t('SpecialGoods.OnlyEnterYN')" style="width:215px;" @change="limitInput" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.CorrectTransportName')">
            <el-input v-model="editObj.correctTransportName" no="24" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.GrossWeight')">
            <el-input-number v-model="editObj.grossWeight" no="25" :min="0" :max="999999999999" :precision="3" controls-position="right" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.NeatWeight')">
            <el-input-number v-model="editObj.neatWeight" no="26" :min="0" :max="999999999999" :precision="3" controls-position="right" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.OuterPackagingType')">
            <el-input v-model="editObj.outerPackagingType" no="27" :style="isEditing ? 'width:170px': 'width:215px'" />
            <!--危险品包装-->
            <span v-if="isEditing" class="el-button el-button--primary el-button--mini" style="min-width:40px!important;margin-left:2px" @click="queryDangerousGoodPackageHandle('outerPackagingType')"><i class="el-icon-search" /></span>
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.OuterPackagingQuantity')">
            <el-input-number v-model="editObj.outerPackagingQuantity" no="28" :min="0" :max="999999999999" controls-position="right" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.InnerPackagingType')">
            <el-input v-model="editObj.innerPackagingType" no="29" :style="isEditing ? 'width:170px': 'width:215px'" />
            <!--危险品包装-->
            <span v-if="isEditing" class="el-button el-button--primary el-button--mini" style="min-width:40px!important;margin-left:2px" @click="queryDangerousGoodPackageHandle('innerPackagingType')"><i class="el-icon-search" /></span>
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.InnerPackagingQuantity')">
            <el-input-number v-model="editObj.innerPackagingQuantity" no="30" :min="0" :max="999999999999" :precision="0" controls-position="right" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.Remark')">
            <special-character-tip :texts="specialCharCheck.remark">
              <el-input v-model="editObj.remark" no="31" type="textarea" :rows="2" style="width:215px;" />
            </special-character-tip>
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.PackingCode')">
            <el-input v-model="editObj.packingCode" no="32" style="width:215px;" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.HazardForm')">
            <el-select v-model="editObj.hazardForm" :disabled="!isEditing" no="hazardForm" style="width:215px;" placeholder="">
              <el-option
                v-for="(item,index) in hazardFormArray"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-if="job.cargoType==='DG'" class="section">
      <span class="title">{{ $t('SeaExport.ContainerInfo') }}</span>
      <div style="display:flex;flex-direction:column">
        <div style="padding:5px 0">
          <div>
            <el-button no="33" :disabled="isEditing" type="primary" @click="pm.linkUsageClickHandler()">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
            <el-button no="34" :disabled="isEditing" type="danger" @click="pm.delLinkUsageClickHandler()">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
          </div>
          <div style="flex:1;display:flex;justify-content:flex-end;padding-right:100px">
            <el-button no="55" :disabled="!isEditing" type="primary" @click="handleAutoDistribute">{{ $t('SeaExport.AutoAllocation') }}</el-button>
          </div>
        </div>
        <cargo-ag-grid
          no="35"
          config-module="20000"
          :grid-options="box.gridOptions"
          :grid-params.sync="box.gridParams"
          :column-defs="boxColumnDefs"
          :row-data="containerUsages"
          style="width:100%;height:220px"
          @gridReady="params=>box.gridApi=params.api"
        />
      </div>
    </div>

    <!-- 挂衣箱 -->
    <div v-if="job.cargoType==='GOH'" class="section">
      <span class="title">{{ $t('SpecialGoods.GOH') }}</span>
      <div style="display:flex;flex-direction:column">
        <div style="display:flex;flex-direction:row">
          <span style="width:100px">{{ $t('SpecialGoods.Tier') }}</span>
          <span style="width:190px">{{ $t('SpecialGoods.Hanger') }}</span>
          <span style="width:190px">{{ $t('SpecialGoods.Ropes') }}</span>
          <span style="width:190px">{{ $t('SpecialGoods.Knots') }}</span>
        </div>
        <div style="display:flex;flex-direction:row">
          <el-input v-model="editObj.gohTier" no="36" style="width:90px;margin-right:10px" :disabled="!isEditing" />
          <el-input v-model="editObj.gohHanger" no="37" style="width:180px;margin-right:10px" :disabled="!isEditing" />
          <el-input v-model="editObj.gohRopes" no="38" style="width:180px;margin-right:10px" :disabled="!isEditing" />
          <el-input v-model="editObj.gohKnots" no="39" style="width:180px" :disabled="!isEditing" />
        </div>
        <div style="display:flex;flex-direction:row;margin-top: 10px;">
          <span style="width:100px">{{ $t('SpecialGoods.ReformCost') }}</span>
          <el-input v-model="editObj.gohReformCost" no="40" style="width:180px" :disabled="!isEditing" />
        </div>
      </div>
    </div>

    <!-- 冷藏箱 -->
    <div v-show="job.cargoType==='RF'" class="section">
      <span class="title">{{ $t('SpecialGoods.Reefer') }}</span>
      <div style="display:flex;flex-direction:column">
        <el-form :inline="true" label-width="95px" label-position="left">
          <el-form-item>
            <div style="display: flex;align-items: center">
              <span slot="label">{{ $t('SpecialGoods.humidity') }}</span>
              <el-tooltip
                :content="$t('SpecialGoods.HumidityToolTip')"
                placement="right-end"
              >
                <img
                  :src="humidityToolTip"
                  width="18"
                  height="28"
                  style="padding: 5px 0;vertical-align: bottom;"
                >
              </el-tooltip>
              <el-input v-model="editObj.reefHumidity" no="41" style="width:160px" :maxlength="8" :disabled="!isEditing" />
            </div>
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.ventilation')">
            <el-input v-model="editObj.reefVentilation" no="42" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
        <el-form :inline="true" label-width="95px" label-position="left">
          <el-form-item :label="$t('SeaExport.SetTemperature')">
            <el-input v-model="editObj.reefTemperature" no="43" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MinimumTemperature')">
            <el-input v-model="editObj.reefLowestTemp" no="44" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MaximumTemperature')">
            <el-input v-model="editObj.reefHighestTemp" no="45" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
        <el-form :inline="true" label-width="95px" label-position="left">
          <el-form-item :label="$t('SpecialGoods.ContainerYard')">
            <el-input v-model="editObj.reefContainerYard" no="46" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SpecialGoods.TemperatureUnit')">
            <el-select
              v-model="editObj.temperatureUnit"
              no="47"
              :disabled="!isEditing"
              :clearable="false"
              style="width:160px"
            >
              <el-option
                v-for="(item,index) in temperatureUnits"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <el-form :inline="true" label-width="95px" label-position="left">
          <el-form-item :label="$t('SeaExport.PortForReturningContainer')">
            <el-input v-model="editObj.reefDeliverTime" no="48" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
        <el-form :inline="true" label-width="95px" label-position="left">
          <el-form-item :label="$t('SpecialGoods.PTI')">
            <el-input v-model="editObj.reefPTI" no="49" style="width:160px" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 加非标准箱 -->
    <div v-show="job.cargoType==='BB'" class="section">
      <span class="title">{{ $t('SeaExport.NonStandardContainer') }}</span>
      <div style="display:flex;flex-direction:column">
        <el-form :inline="true" label-width="40px" label-position="left">
          <el-form-item :label="$t('SeaExport.OverFront')">
            <el-input-number v-model="editObj.overFront" no="50" :controls="false" :min="0" :precision="0" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverBack')">
            <el-input-number v-model="editObj.overBack" no="51" :controls="false" :min="0" :precision="0" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverHeight')">
            <el-input-number v-model="editObj.overHeight" no="52" :controls="false" :min="0" :precision="0" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
        <el-form :inline="true" label-width="40px" label-position="left">
          <el-form-item :label="$t('SeaExport.OverLeft')">
            <el-input-number v-model="editObj.overLeft" no="53" :controls="false" :min="0" :precision="0" :disabled="!isEditing" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverRight')">
            <el-input-number v-model="editObj.overRight" no="54" :controls="false" :min="0" :precision="0" :disabled="!isEditing" />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 选择装箱信息弹窗 -->
    <special-goods-container-usage-dialog
      :visible.sync="containerUsageDialog.visible"
      :job-uuid="job.uuid"
      @linkUsagesEventHandler="linkUsagesEventHandler"
    />

    <!-- 危险品-关联业务 -->
    <special-goods-dialog
      :visible.sync="specialGoodsDialog.visible"
      :a-data="specialGoodsDialog.aData"
      :o-job="specialGoodsDialog.oJob"
      :job="specialGoodsDialog.job"
      @refreshCache="refreshCache"
    />

    <imdg-code-select-dialog
      :visible.sync="imdgCodeSelDialog.visible"
      :imdg-codes="imdgCodeSelDialog.imdgCodes"
      @onImdgCodeSelSucceed="onImdgCodeSelSucceed"
    />

    <!--    危险品包装-->
    <dangerous-good-package-dialog
      :visible.sync="dangerousGoodsDialog.visible"
      :type="dangerousGoodsDialog.type"
      @dangerousGoodPackage="dangerousGoodPackageCallBack"
      @close="dangerousGoodsDialog.visible=false"
    />
  </div>
</template>

<script>

import { TabSpecialGoodsBase } from './tabSpecialGoodsBase'
import StrUtils from '@/utils/StrUtils'
import { TabError } from '@/utils/class/TabError'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'
import SpecialGoodsContainerUsageDialog
  from '@/components/Cargo/Job/specialGoodsContainerUsageDialog'
import { querySpecialAssociatedBusiness } from '@/api/seaExport/containerUsage'
import SpecialGoodsDialog from '@/components/Cargo/Job/specialGoodsDialog'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SpecialGoods } from '@/class/model/booking/SpecialGoods'
import ImdgCodeSelectDialog from '@/components/Cargo/Job/imdgCodeSelectDialog'
import { importSpecialGoods, relatedContainerUsages } from '@/api/seaExport/specialGoods'
import { getDangerousGoodsList } from '@/api/basicData/dangerousGoods'
import humidityToolTip from '@/assets/humidityToolTip.png'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import $store from '@/store'
import { cache, cacheName } from '@/utils/cacheManager'
import DangerousGoodPackageDialog from '@/components/Cargo/Job/dangerousGoodPackageDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { poItems } from '@/api/seaExport/poItems'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip.vue'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'TabSpecialGoods',
  components: { specialCharacterTip, DangerousGoodPackageDialog, ImdgCodeSelectDialog, SpecialGoodsDialog, SpecialGoodsContainerUsageDialog },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pm: new TabSpecialGoodsBase(this),
      specialGoods: [],
      dangerousGoods: [],
      editObj: new SpecialGoods().fillDefaultValue().getData(),
      containerUsages: [],
      currentState: '',
      dangerousInputMode: false, // 危险品输入模式
      isEditing: false,
      enablePrint: false,
      job: { cargoType: '' },
      delSpecialGoodsUuids: [],
      btnshowAWindow: false,
      editLog: false,
      specialGoodsDialog: {
        visible: false,
        aData: {}
      },
      imdgCodeSelDialog: {
        visible: false
      },
      containerUsageDialog: {
        visible: false
      },
      danger: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowClicked: this.goodsItemClickHandler
        },
        rowData: [],
        gridApi: null
      },
      dangerousGoodsDialog: {
        visible: false,
        type: null
      },
      specialCharCheck: {
        remark: null
      },
      box: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      colSoNo: [], // soNoList
      humidityToolTip, // 湿度提示图片
      isZh: $store.getters.language === 'zh',
      temperatureUnits: SystemConstants.TEMPERATURE_UNITS,
      danClassNos: SystemConstants.DAN_CLASS_NOS,
      packingGoods: SystemConstants.PACKING_GOODS,
      flashPointUnitArray: SeaExportConstants.REEF_TEMP_UNITS,
      hazardFormArray: SeaExportConstants.HAZARD_FORM_ARR
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    dangerColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.SpecialCargoNumber'),
          field: 'danNo',
          width: 133
        },
        {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'englishCommodity',
          width: 109,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-input'
          }
        },
        {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'chineseCommodity',
          width: 109,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-input'
          }
        },
        {
          headerName: 'SONO.',
          field: 'soNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-select',
            optionField: {
              label: 'sonos',
              value: 'sonos',
              filterable: false
            },
            attrs: {
              cellSelectAttrs: { fullOptions: [... this.colSoNo] }
            }
          }
        }
      ]
      return columnDefs
    },
    boxColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 100,
          cellRenderer: (params) => {
            return this.eqSizeItemLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'grossWeight',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        },
        {
          headerName: this.$t('SeaExport.NetWeight'),
          field: 'neatWeight',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        },
        {
          headerName: this.$t('SpecialGoods.OuterPackagingQuantity'),
          field: 'outerPackagingQuantity',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        },
        {
          headerName: this.$t('SpecialGoods.InnerPackagingQuantity'),
          field: 'innerPackagingQuantity',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerId'),
          field: 'containerId',
          width: 80
        },
        {
          headerName: this.$t('SeaExport.ContainerSeqNo'),
          field: 'containerSeqNo',
          width: 80
        }
      ]
      return columnDefs
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.dangerousInputMode = parseInt(cache.config.get('DangerousInputMode')) === 1
  },
  methods: {
    async onShow(row, isRefresh) {
      this.delSpecialGooodsUuids = []
      this.job = row
      if (!this.job.poItems && this.job.uuid) {
        this.job.poItems = await poItems({ jobUuid: this.job.uuid }).then(res => res.data)
      }
      // console.log('====', getCacheListByKey('basic_data_CargoType'))

      // 判断是否分公司委托货或跨tenant委托
      const consignationByCompany = StrUtils.isEmpty(this.job.relatedJob) && this.isEdit
      const consignationByTenant = !StrUtils.isEmpty(this.job.relatedJob) && this.isEdit // todo 暂无此属性 && this.job.crossTenantHistoryState > -1
      this.isEditing = consignationByCompany || consignationByTenant
      if (!isRefresh) {
        this.pm.loadColSoNo()
        return
      }

      this.btnshowAWindow = (StrUtils.isEmpty(this.job.relatedJob) && !StrUtils.isEmpty(this.job.trustFromJob)) ||
        (StrUtils.isEmpty(this.job.trustFromJob) && !StrUtils.isEmpty(this.job.relatedJob))

      await this.pm.dataChanged()
      this.goodsItemClickHandler({ data: this.editObj })
      this.initDangerousGoods()
      this.checkSpecialCharacter()
    },

    checkSpecialCharacter() {
      if (Number(cache.config.get('SpecialCharacterCheck')) === 1) {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = StrUtils.getSpecialTexts(this.editObj[key])
        }
      } else {
        for (const key in this.specialCharCheck) {
          this.specialCharCheck[key] = null
        }
      }
    },
    async txtdDnUNNoFocusOutHandler() {
      const editObj = this.editObj
      const elSelect = this.$refs.danUNNo
      const innerInput = elSelect.$children[0].$refs.input
      if (innerInput.value) {
        editObj.danUNNo = innerInput.value
      }
    },

    // 联合国编号下拉框
    initDangerousGoods() {
      this.dangerousGoods = []
      getDangerousGoodsList('').then(res => {
        console.info('res.data.list：' + res.data.list)
        this.dangerousGoods = res.data.list
      })
    },

    async getSubmitData() {
      let specialGoods = []
      if (this.job.cargoType === 'DG') {
        this.validateForm()
        specialGoods = this.specialGoods
      } else {
        specialGoods.push(this.editObj)
      }
      for (const sData of specialGoods) {
        JobUtils.checkSpecialCharacters(sData, 'remark')
      }
      const needConfirm = this.checkNeedConfirm(specialGoods)
      if (needConfirm) {
        await this.$confirm(this.$t('SeaExport.HaveMaintainedSpecialInfo'), this.$t('SeaExport.AutoSpecialGoods'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(async() => {
          this.getPackingInfo(specialGoods)
        }).catch(() => {})
      }
      return {
        specialGoods,
        delSpecialGoodsUuids: this.delSpecialGoodsUuids
      }
    },
    // 校验是否存在需要导入的货物明细装箱
    checkNeedConfirm(specialGoods) {
      let needConfirm = false
      for (const item of specialGoods) {
        if (item.englishCommodity && item.hsCode && this.containerUsages && this.containerUsages.length === 0) {
          needConfirm = true
        }
      }
      return needConfirm
    },
    getPackingInfo(specialGoods) {
      let needTips = false
      for (const item of specialGoods) {
        if (!item.uuid || !item.englishCommodity || !item.hsCode) {
          continue
        }
        const keysList = []
        // 遍历货物明细
        for (const poItem of this.job.poItems) {
          if (poItem.containerUsageKey && poItem.cargoType === 'DG' && poItem.englishCommodity === item.englishCommodity && poItem.hsCode === item.hsCode) {
            // 存在绑定则跳过 若无绑定关系，则绑定特殊货物明细和货物明细对应的装箱明细ID
            const isExist = this.containerUsages.some(p => { return poItem.containerUsageKey === p.containerUsageUuid })
            if (isExist) {
              continue
            }
            keysList.push(poItem.containerUsageKey)
          }
        }
        if (keysList && keysList.length > 0) {
          relatedContainerUsages({ specialGoodsUuid: item.uuid, usageIds: keysList })
          needTips = true
        }
      }
      if (needTips) {
        this.pm.saveRelatedResulthandler(this.$t('SeaExport.PackingInformation'))
      } else {
        this.$message.warning(this.$t('SeaExport.NoPackingInformation'))
      }
    },
    validateForm() {
      // 如果外包装类型是4G，则内包装类型栏和内包装件数栏位必须要求填写
      for (const spg of this.specialGoods) {
        this.validateFormItem(spg)
        if (!StrUtils.isEmpty(spg.outerPackagingType)) {
          const outPacking = spg.outerPackagingType
          if (outPacking === '4G') {
            // CARGO-48927 特殊货物信息页签中，内包装为UNPKG时，内包装为0可以保存
            // if (StrUtils.isEmpty(spg.innerPackagingType)) {
            //   throw new TabError(this.$t('Message.InnerPackagingTypeIsRequired'), 'tabSpecialGoods')
            // }
            // if (!spg.innerPackagingQuantity) {
            //   throw new TabError(this.$t('Message.InnerPackagingQuantityIsRequired'), 'tabSpecialGoods')
            // }
          }
        }
        if (!StrUtils.isEmpty(spg.danSeaPullution)) {
          const seaPollution = spg.danSeaPullution
          const isPollutionCheckFailed = !StrUtils.isEmpty(seaPollution) && seaPollution !== 'Y' && seaPollution !== 'N'
          if (isPollutionCheckFailed) {
            throw new TabError(this.$t('Message.SeaPollutionOnlyEnterYN'), 'tabSpecialGoods')
          }
        }
        const containerUsages = spg.containerUsageVOS
        if (containerUsages && containerUsages.length > 0) {
          const matchingContainerUsages = containerUsages.filter(
            (containerUsage) => containerUsage.specialGoodsUuid === spg.uuid
          )
          if (matchingContainerUsages && matchingContainerUsages.length > 0) {
            let totalGrossWeight = 0.0 // 毛重总计
            let totalNeatWeight = 0.0 // 净重总计
            let totalInnerPackagingQuantity = 0 // 内包装件数总计
            let totalOuterPackagingQuantity = 0 // 外包装件数总计

            matchingContainerUsages.forEach((item) => {
              totalGrossWeight += NumberUtils.ToFixed2(item.grossWeight, 3) || 0 // 累加毛重，避免字段为 undefined
              totalNeatWeight += NumberUtils.ToFixed2(item.neatWeight, 3) || 0 // 累加净重，避免字段为 undefined
              totalInnerPackagingQuantity += Number(item.innerPackagingQuantity || 0) // 累加内包装件数
              totalOuterPackagingQuantity += Number(item.outerPackagingQuantity || 0) // 累加外包装件数
            })
            if (totalGrossWeight === 0.0 && totalNeatWeight === 0.0 && totalInnerPackagingQuantity === 0 && totalOuterPackagingQuantity === 0) {
              continue
            }
            if (NumberUtils.ToFixed2(totalGrossWeight, 3) !== NumberUtils.ToFixed2(spg.grossWeight, 3) || NumberUtils.ToFixed2(totalNeatWeight, 3) !== NumberUtils.ToFixed2(spg.neatWeight, 3) ||
                totalInnerPackagingQuantity !== spg.innerPackagingQuantity || totalOuterPackagingQuantity !== spg.outerPackagingQuantity) {
              throw new TabError(this.$t('Message.ContainerTotalNeedEqual'), 'tabSpecialGoods')
            }
          }
        }
      }
      return true
    },
    validateFormItem(item) {
      // 用于在UI自定义中，添加相关校验
    },
    goodsItemClickHandler(event) {
      this.pm.goodsItemClickHandler(event)
    },
    // 查看关联业务
    showAWindowClickHandler() {
      const params =
        {
          trustFromJobNo: this.job.trustFromJob,
          relatedJobNo: this.job.relatedJob
        }
      //  调用api
      querySpecialAssociatedBusiness(params).then(res => {
        this.queryWindowResultHandler(res.data)
      })
    },
    queryWindowResultHandler(data) {
      const nJob = data.resultSea // SeaExportJob
      nJob.specialGoods = data.specialGoods
      if (nJob.cargoType === 'DG') {
        this.specialGoodsDialog.aData = data
        this.specialGoodsDialog.job = nJob
        this.specialGoodsDialog.oJob = this.job
        this.specialGoodsDialog.currentStateType = this.currentState
        this.specialGoodsDialog.visible = true
      } else {
        this.$message.info(this.$t('SeaExport.RelatedBusinessNoSpecial'))
      }
    },
    async refreshCache() {
      const jobClass = new SeaExportJob(this.job)
      jobClass.specialGoods = ''
      await jobClass.getSpecialGoods()
      this.specialGoods = this.job.specialGoods

      this.pm.loadSuccess()
    },
    eqSizeItemLabelFunc(value) {
      const eqSize = EQSize.getEQSizeByCode(value)
      return eqSize === null ? '' : eqSize.name
    },
    linkUsagesEventHandler(data) {
      this.pm.linkUsagesEventHandler(data)
    },
    limitInput(val) {
      if (val !== 'Y' && val !== 'N') {
        this.editObj.danSeaPullution = ''
      }
    },
    onImdgCodeSelSucceed(data) {
      this.pm.onImdgCodeSelSucceed(data)
    },

    beforeUploadSpgGoods(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'png'
      const extension2 = fileType === 'jpeg'
      const extension3 = fileType === 'jpg'
      if (!extension && !extension2 && !extension3) {
        this.$message.error(this.$t('SeaExport.UploadImageFormatWrong'))
      }
      return extension || extension2
    },
    // 危险品-导入
    importSpGoods(item) {
      const jobParams = { ... this.job }
      for (const key in jobParams) {
        if (typeof jobParams[key] === 'object') {
          delete jobParams[key]
        }
      }

      const params = {
        file: item.file,
        job: JSON.stringify(jobParams)
      }
      importSpecialGoods(params).then(response => {
        if (response.data == null || response.data === '') {
          this.$message.warning(this.$t('SeaExport.FileContentWrong'))
        } else {
          this.pm.importResultHandler(response.data)
        }
      })
    },
    queryDangerousGoodPackageHandle(type) {
      this.dangerousGoodsDialog.type = type
      this.dangerousGoodsDialog.visible = true
    },
    dangerousGoodPackageCallBack(e) {
      if (e && e.type && e.data) {
        this.editObj[e.type] = e.data.code
      }
    },
    // 组装打印参数
    getPrintData() {
      if (!this.editObj.uuid) {
        this.$message.warning(this.$t('SeaExport.ChooseSpecialGoods'))
        return
      }
      const params = {}
      if (this.job && this.editObj.uuid) {
        params.jobuuid = this.job.uuid
        params.JOB_UUID = this.job.uuid
        params.SPECIAL_GOOD_UUID = this.editObj.uuid
        params.category = 'SPECIAL_GOODS'
        params.ctx = new SeaExportJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(job, "SPECIAL_GOODS", params, this);
      }
      this.$logger.log('params', params)
      return params
    },
    handleAutoDistribute() {
      if (!this.containerUsages || this.containerUsages.length === 0) {
        return
      }
      let usage
      let tsize = 0
      for (usage of this.containerUsages) {
        const eqsize = EQSize.getEQSizeByCode(usage.eqSize)
        if (eqsize) { tsize += parseInt(eqsize.code) }
      }
      let outer = 0
      let inner = 0
      let gross = 0
      let neat = 0
      const totalContainers = this.containerUsages.length
      const totalOuterPacking = this.editObj.outerPackagingQuantity || 0
      const totalInnerPacking = this.editObj.innerPackagingQuantity || 0
      const totalGrossWeight = NumberUtils.ToFixed2(this.editObj.grossWeight || 0, 3)
      const totalNeatWeight = NumberUtils.ToFixed2(this.editObj.neatWeight || 0, 3)
      if (totalOuterPacking === 0 && totalInnerPacking === 0 && totalGrossWeight === 0 && totalNeatWeight === 0) { return }
      for (let i = 0; i < totalContainers; i++) {
        usage = this.containerUsages[i]
        if (i === totalContainers - 1) {
          usage.outerPackagingQuantity = NumberUtils.roundHalfUp(totalOuterPacking - outer, 0)
          usage.innerPackagingQuantity = NumberUtils.roundHalfUp(totalInnerPacking - inner, 0)
          usage.grossWeight = NumberUtils.roundHalfUp(totalGrossWeight - gross, 3)
          usage.neatWeight = NumberUtils.roundHalfUp(totalNeatWeight - neat, 3)
        } else {
          const size = EQSize.getEQSizeByCode(usage.eqSize)
          const rate = parseInt(size.code) / tsize
          outer += usage.outerPackagingQuantity = NumberUtils.roundHalfUp(rate * totalOuterPacking, 0)
          inner += usage.innerPackagingQuantity = NumberUtils.roundHalfUp(rate * totalInnerPacking, 0)
          gross += usage.grossWeight = NumberUtils.roundHalfUp(rate * totalGrossWeight, 3)
          neat += usage.neatWeight = NumberUtils.roundHalfUp(rate * totalNeatWeight, 3)
        }
      }
      // 刷新表格
      this.box.gridApi.refreshCells()
    }
  }
}
</script>

<style lang="scss">
#app {
  .tab-special-goods {
    .bold {
      .el-form-item__label {
        font-weight: bold;
        font-size: 14px;
      }
    }
  }
}
</style>
